import { cadenzaSessionStorage } from '@disy/lib/storage';

import type { WorldBoxDto } from 'cadenza/api-client/dto/world-box-dto';
import type { WorkbookName } from 'cadenza/repository/model/workbook-name.gen';
import type { ViewId } from 'cadenza/workbook/api/view-id';

/**
 * Save mapExtent for given map view in sessionStorage.
 *
 * @param workbookName - the name of the workbook
 * @param viewId - viewId for map view
 * @param extent - Extent of the map view
 */
export function saveExtentToSession(workbookName: WorkbookName, viewId: ViewId, extent: WorldBoxDto): void {
  cadenzaSessionStorage.setItem(_extentSessionKey(workbookName, viewId), JSON.stringify(extent));
}

/**
 *  Loads mapExtent for given workbookId and viewId from sessionStorage
 *
 * @param workbookName - the name of the workbook
 * @param viewId - viewId for map view
 * @return Extent of the map view or undefined
 */
export function loadExtentFromSession(workbookName: WorkbookName, viewId: ViewId) {
  const item = cadenzaSessionStorage.getItem(_extentSessionKey(workbookName, viewId));
  if (item) {
    return JSON.parse(item) as WorldBoxDto;
  }
}

function _extentSessionKey(workbookName: WorkbookName, viewId: ViewId): string {
  return `mapState.${workbookName}.${viewId}.extent`;
}

// If this is set, a toast message is shown to the user on initializing the workbook.
export const USER_MESSAGE_STORAGE_KEY = 'd-workbook.init-toast-message';
